import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'SpaceMembersPage.MemberManagement',
    defaultMessage: 'Space Member Management'
  },
  loading: {
    id: 'Loading',
    defaultMessage: 'Loading...'
  },
  addUser: {
    id: 'SpaceMembersPage.AddMember',
    defaultMessage: 'Add Member'
  }
})
